const Fallback = () => {
    console.log("Fallback running");
  return (
    <h1>Fallback</h1>
  )
}

export default Fallback